import type {
  PublisherDetailSerializer,
  IApiResponse,
  FacetedArtsDataSerializer,
  FacetedArtsResponseSerializer,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";
import type { IArtsFacetsRequest } from "../../types/api";

export enum ArtPublisherSortingEnum {
  POPULAR = "popular",
  NEW = "new",
}

export interface IPublishersArtsFacetsRequest extends IArtsFacetsRequest {
  publisherSlug: string | number;
  o?: ArtPublisherSortingEnum;
}

export const publishersApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getPublisherDescription: build.query<
      PublisherDetailSerializer,
      {
        publisherSlug: number | string;
      }
    >({
      query: ({ publisherSlug }) => ({
        url: `/foundation/api/publishers/${publisherSlug}`,
      }),
      transformResponse: (
        response: IApiResponse<PublisherDetailSerializer>
      ) => {
        return response.payload.data;
      },
    }),
    /** запрос на фасеты для новой сетки, мерж  не нужен
     */
    getPublisherFacets: build.query<
      FacetedArtsDataSerializer,
      IPublishersArtsFacetsRequest
    >({
      query: ({ publisherSlug, limit = 24, offset = "0", ...params }) => ({
        url: `/foundation/api/publishers/${publisherSlug}/arts/facets`,
        params: {
          ...params,
          limit,
          offset,
        },
      }),
      transformResponse: (response: FacetedArtsResponseSerializer) =>
        response.payload,
    }),
  }),
});
